import React, { useState } from "react";
import fetchBase from "../utils/fetchBase";
import SignaturePad from "./SignaturePad";

const OigPreview = ({ data, onDiscarded, onConfirmed }) => {
    const authHeader = "Bearer " + localStorage.getItem("jwt_token");
    const [confirming, setConfirming] = useState(false);
    const [signatureStage, setSignatureStage] = useState(null); // "initials" | "signature" | null
    const [initialsData, setInitialsData] = useState(null);

    const discard = async () => {
        await fetch(`${fetchBase}/api/security/oig-checks/${data.checkId}`, {
            method: "DELETE",
            headers: { Authorization: authHeader }
        }).catch(() => {});
        onDiscarded();
    };

    const startConfirm = () => {
        setSignatureStage("initials");
    };

    const handleSaveInitials = (dataUrl) => {
        setInitialsData(dataUrl);
        setSignatureStage("signature");
    };

    const handleSaveSignature = async (dataUrl) => {
        setConfirming(true);
        try {
            await fetch(`${fetchBase}/api/security/oig-checks/${data.checkId}/confirm`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: authHeader },
                body: JSON.stringify({ initialsSignature: initialsData, fullSignature: dataUrl })
            });
            onConfirmed();
        } catch (err) {
            console.error("Failed to confirm OIG check:", err);
            alert("Failed to confirm.");
        } finally {
            setConfirming(false);
            setSignatureStage(null);
        }
    };

    // Quotation-mark repeat formatting: if a cell's value equals the row above it
    // in the same column, render " instead of repeating the value.
    const cell = (value, index, arr, key) => {
        if (index > 0 && arr[index - 1][key] === value) return "\"";
        return value ?? "";
    };

    const cellStyle = { border: "1px solid #000", padding: "5px 8px", fontSize: "11px", textAlign: "center", color: "#000" };
    const headerStyle = { ...cellStyle, fontWeight: 700, background: "#f2f2f2", color: "#000" };

    return (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999, overflowY: "auto", padding: "40px 0" }}>
            <div style={{ background: "#fff", borderRadius: "14px", padding: "24px", width: "95%", maxWidth: "1100px" }}>
                <h2 style={{ fontSize: "16px", fontWeight: 700, textAlign: "center", margin: "0 0 4px", color: "#000" }}>
                    {data.organizationName}
                </h2>
                <p style={{ fontSize: "14px", fontWeight: 700, textAlign: "center", margin: "0 0 4px", color: "#000" }}>
                    PAS EMPLOYEE VERIFICATION FORM
                </p>
                <p style={{ fontSize: "13px", fontWeight: 600, textAlign: "center", margin: "0 0 16px", color: "#000" }}>
                    OIG FEDERAL / STATE SEARCH
                </p>

                <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", minWidth: "900px", borderCollapse: "collapse", marginBottom: "16px" }}>
                        <thead>
                            <tr>
                                <th style={headerStyle}>Employee Name</th>
                                <th style={headerStyle}>Date of Birth</th>
                                <th style={headerStyle}>Federal OIG Y/N</th>
                                <th style={headerStyle}>Date Verified Federal</th>
                                <th style={headerStyle}>State OIG Y/N</th>
                                <th style={headerStyle}>Date Verified State</th>
                                <th style={headerStyle}>Self Reported Y/N</th>
                                <th style={headerStyle}>Self Report Attached Y/N</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.results.map((r, i, arr) => (
                                <tr key={r.resultId}>
                                    <td style={cellStyle}>{r.employeeName}</td>
                                    <td style={cellStyle}>{r.dateOfBirth || "—"}</td>
                                    <td style={cellStyle}>{r.federalAppeared ? "Y" : "N"}</td>
                                    <td style={cellStyle}>{cell(r.federalDateVerified, i, arr, "federalDateVerified")}</td>
                                    <td style={cellStyle}>{r.stateAppeared ? "Y" : "N"}</td>
                                    <td style={cellStyle}>{cell(r.stateDateVerified, i, arr, "stateDateVerified")}</td>
                                    <td style={cellStyle}>{r.selfReported ? "Y" : "N"}</td>
                                    <td style={cellStyle}>{r.selfReportAttached ? "Y" : "N"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <p style={{ fontSize: "12px", margin: "0 0 16px" }}>
                    <strong>Person Completing Search:</strong> {data.searcherFirstName} {data.searcherLastName}
                </p>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button onClick={discard} disabled={confirming}
                        style={{ background: "#f5f5f7", color: "#1d1d1f", border: "none", borderRadius: "8px", padding: "10px 20px", fontSize: "14px", fontWeight: 600, cursor: "pointer" }}>
                        Discard
                    </button>
                    <button onClick={startConfirm} disabled={confirming}
                        style={{ background: "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 20px", fontSize: "14px", fontWeight: 600, cursor: "pointer" }}>
                        Confirm
                    </button>
                </div>
            </div>

            {signatureStage === "initials" && (
                <SignaturePad label="Verified By — Initials" onSave={handleSaveInitials} />
            )}
            {signatureStage === "signature" && (
                <SignaturePad label="Verified By — Signature" onSave={handleSaveSignature} />
            )}
        </div>
    );
};

export default OigPreview;